/*tslint:disable*/

export class ActivityLevel {
  public activityLevelId: number = 0;
  public activityId: number = 0;
  public activityLevel: ActivityLevelType;
  public activityLevelStatus: ActivityLevelStatus;
  public insertedOn: Date | any = null;
  public insertedBy: string = '';
  public updatedOn: Date | any = null;
  public updatedBy: string = '';
}

export enum ActivityLevelStatus {
  Active = 'Active',
  Deleted = 'Deleted'
}

export enum ActivityLevelType {
  Club = 'Club',
  District = 'District'
}
